import { createContext } from 'react';
import { ScheduleContextType } from '../types';

export const ScheduleContextObject = createContext<ScheduleContextType | undefined>(undefined);